
import FormPreview from 'vux/src/components/form-preview/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'

export default {
components: {
FormPreview,
XTable
},
data () {
return {
list: []
}
},
activated: function () {
this.list = [{
label: '结汇方式名称',
value: this.$route.params.Item.PES_Name
}, {
label: '结汇方式说明',
value: this.$route.params.Item.PES_Remark
}]
}
}



// WEBPACK FOOTER //
// ./src/components/ExchangeSettlementDetail.vue